import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  connect() {
    const checkbox = this.element.querySelector("input[type='checkbox']")
    const checked = checkbox.checked

    const button = this.element.querySelector("button")
    button.setAttribute("aria-checked", checked)
    button.classList.toggle("bg-primary", checked)
    button.classList.toggle("bg-default", !checked)

    const span = button.querySelector("span")
    span.classList.toggle("translate-x-5", checked)
    span.classList.toggle("translate-x-0", !checked)
  }

  switch(event) {
    const button = event.currentTarget
    const checked = button.getAttribute("aria-checked") === "true"

    button.setAttribute("aria-checked", !checked)
    button.classList.toggle("bg-primary", !checked)
    button.classList.toggle("bg-default", checked)

    const span = button.querySelector("span")
    span.classList.toggle("translate-x-5", !checked)
    span.classList.toggle("translate-x-0", checked)

    const checkbox = this.element.querySelector("input[type='checkbox']")
    checkbox.checked = !checked
    checkbox.value = checkbox.checked ? 1 : 0
  }

  static targets = ["toggleable"]

  toggle(event) {
    event.preventDefault()
    this.toggleableTargets.forEach((target) => {
      // taget.classList 에 data-css-class 가 있는지 확인하고 있으면 제거하고 없으면 추가한다.
      if (target.classList.contains(target.dataset.cssClass)) {
        target.classList.remove(target.dataset.cssClass)
      } else {
        target.classList.add(target.dataset.cssClass)
      }
    })
  }
}
